var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignatoryEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63575_39876)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D0DEF5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    stroke: "#103861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7H6.5C6.23478 7 5.98043 7.10536 5.79289 7.29289C5.60536 7.48043 5.5 7.73478 5.5 8V16C5.5 16.2652 5.60536 16.5196 5.79289 16.7071C5.98043 16.8946 6.23478 17 6.5 17H18.5C18.7652 17 19.0196 16.8946 19.2071 16.7071C19.3946 16.5196 19.5 16.2652 19.5 16V8C19.5 7.73478 19.3946 7.48043 19.2071 7.29289C19.0196 7.10536 18.7652 7 18.5 7ZM17.4 8L12.5 11.39L7.6 8H17.4ZM6.5 16V8.455L12.215 12.41C12.2987 12.4681 12.3981 12.4992 12.5 12.4992C12.6019 12.4992 12.7013 12.4681 12.785 12.41L18.5 8.455V16H6.5Z",
    fill: "#103861"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63575_39876"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatoryEmail);
export default __webpack_public_path__ + "static/media/SignatoryEmail.b17c9fa77209a41b3905c0bb720fd825.svg";
export { ForwardRef as ReactComponent };